module.exports = __webpack_public_path__ + "img/chevron_up.2cda0e81.svg";